<template>
    <a class="iconbutton" role="button" tabindex="0" aria-label="Remove" :aria-disabled="disabled"
       @click="$emit('click')" @keydown.enter.prevent="$emit('click')" @keydown.space.prevent="$emit('click')">
        <img alt="" aria-hidden="true" src="@/assets/remove.png"  class="iconimage" >
    </a>
</template>

<script>
export default {
    name:'removebutton',
    props:{
        
        disabled:{
          type:Boolean,
          default:false
        }
    },
    data() {
        return {
            
        };
    },
}
</script>

<style scoped>

.iconbutton:hover{
    
    cursor:pointer;
}

.iconimage{
    width:17px;
}
</style>